let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ldRrg")).then(() => parcelRequire('b8ZPO'));